import { render, staticRenderFns } from "./HomepageFilter.vue?vue&type=template&id=04ff2438&"
import script from "./HomepageFilter.vue?vue&type=script&lang=js&"
export * from "./HomepageFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports